/* esm.sh - tablesorter@2.32.0 */
import "/v135/jquery@3.6.1/esnext/jquery.mjs";
export * from "/v135/tablesorter@2.32.0/X-ZC9qcXVlcnlAMy42LjE/esnext/tablesorter.mjs";
export { default } from "/v135/tablesorter@2.32.0/X-ZC9qcXVlcnlAMy42LjE/esnext/tablesorter.mjs";
